export const menu = [
    {
        id: 1,
        title: "KNVD 소개",
        href: "/about",
        icon: "",
        role: "",
        sub: [
            { id: 11, title: "KISA 취약점 처리 절차", href: "/about/vulnerability", role: "" },
            { id: 12, title: "핵더챌린지 분석플랫폼", href: "/about/hackthechallenge", role: "" },
            { id: 13, title: "법률 안내", href: "/about/law", role: "" },
            { id: 14, title: "이용 가이드", href: "/about/guide" },
        ],
    },
    {
        id: 2,
        title: "KNVD 안내",
        href: "/overview",
        icon: "",
        role: "",
        sub: [
            { id: 21, title: "보안 취약점 신고포상제", href: "/overview/bugbounty", role: "" },
            { id: 22, title: "공동 운영 제도", href: "/overview/operation", role: "" },
            { id: 23, title: "공동 운영사 소개", href: "/overview/operation/intro", role: "" },
            { id: 24, title: "공동 운영사 신고 범위", href: "/overview/operation/range", role: "" },
            { id: 25, title: "자주 묻는 질문", href: "/overview/faq", role: "" },
            { id: 26, title: "명예의 전당", href: "/overview/honor", role: "" },
        ],
    },
    {
        id: 3,
        title: "취약점 제보",
        href: "/report",
        icon: "",
        role: "",
        sub: [
            { id: 31, title: "취약점 신고 접수", href: "/report/submission", role: "" },
            { id: 32, title: "취약점 신고 관리", href: "/report/records", role: "" },
            {
                id: 33,
                title: "핵더챌린지 분석플랫폼 접속",
                href: "/report/hackthechallenge/access",
                role: "",
            },
        ],
    },
    {
        id: 4,
        title: "취약점 조치",
        href: "/patch",
        icon: "",
        role: "",
        sub: [
            { id: 41, title: "취약점 패치 접수", href: "/patch/submission", role: "" },
            { id: 42, title: "취약점 패치 관리", href: "/patch/records", role: "" },
            {
                id: 43,
                title: "핵더챌린지 분석플랫폼 관리",
                href: "/patch/hackthechallenge/access",
                role: "",
            },
        ],
    },
    {
        id: 5,
        title: "취약점 정보",
        href: "/info",
        icon: "",
        role: "",
        sub: [
            { id: 51, title: "보안공지", href: "/info/vuln/notice", role: "" },
            { id: 52, title: "공지사항", href: "/info/notice", role: "" },
            { id: 53, title: "공개된 취약점", href: "/info/vuln/public", role: "" },
            { id: 54, title: "CVE 게시판", href: "/info/cve", role: "" },
        ],
    },
];

export const singleMenuMap = {
    rss: "RSS",
    myPage: "마이 페이지",
    remove: "회원 탈퇴",
    privacyPolicy: "개인정보 처리방침",
    foreigners: "Email Authentication",
    keywordResult: "통합검색",
    findMemberInfo: "사용자 정보 찾기",
    nonMember: "신고자 본인인증",
    joinReporter: "회원가입",
    joinManufacturer: "회원가입",
    joinType: "회원가입",
    childAuth: "보호자 동의 및 본인인증",
    securityScan: "내 PC 취약점 검사",
    securityScanDetail: "내 PC 취약점 검사",
};
